import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.some.js";
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, unref as _unref, createBlock as _createBlock, resolveDynamicComponent as _resolveDynamicComponent } from "vue";
const _hoisted_1 = {
  class: "site-header"
};
const _hoisted_2 = {
  class: "site-nav",
  "aria-label": "主导航"
};
const _hoisted_3 = {
  key: 0,
  class: "desktop-links"
};
const _hoisted_4 = {
  key: 0,
  class: "notice-dot",
  "aria-label": "有新公告"
};
const _hoisted_5 = {
  id: "mobile-navigation",
  class: "mobile-navigation",
  "aria-label": "手机导航"
};
const _hoisted_6 = {
  key: 0,
  class: "notice-dot",
  "aria-label": "有新公告"
};
import { ref, computed, watch, onMounted, onUnmounted } from 'vue';
import { useWindowSize } from '@vueuse/core';
import { useRoute } from 'vue-router';
import { House, PriceTag, Monitor, Picture, Tools, ChatRound, Document, InfoFilled, Bell, Menu, Top, ArrowRight } from '@element-plus/icons-vue';
import { noticeFeed, loadNoticeFeed, hasRead } from '../services/announcements';
import { isGuidePreview } from '../data/guide-preview';
export default {
  __name: 'Header',
  setup(__props) {
    const navigation = [{
      to: '/',
      short: '首页',
      label: '首页',
      icon: House
    }, {
      to: '/price',
      short: '物价',
      label: '物价查询',
      icon: PriceTag
    }, {
      to: '/television',
      short: '电视',
      label: '电视成交',
      icon: Monitor
    }, {
      to: '/display',
      short: '展示',
      label: '图纸展示',
      icon: Picture
    }, {
      to: '/tools',
      short: '工具',
      label: '实用工具',
      icon: Tools
    }, {
      to: '/tutorial',
      short: '资料',
      label: '游戏资料',
      icon: Document
    }, {
      to: '/free',
      short: '留言',
      label: '留言',
      icon: ChatRound
    }, {
      to: '/announcements',
      short: '公告',
      label: '公告中心',
      icon: Bell
    }, {
      to: '/about',
      short: '关于',
      label: '关于本站',
      icon: InfoFilled
    }];
    const route = useRoute(),
      drawer = ref(false),
      showBackToTop = ref(false),
      {
        width
      } = useWindowSize();
    const isMobile = computed(() => width.value < 1024),
      unread = computed(() => noticeFeed.value.some(n => !hasRead(n)));
    const isActive = path => path === '/' ? route.path === '/' : route.path === path || route.path.startsWith(path + '/');
    function select(path) {
      drawer.value = false;
      if (path === '/television') window.dispatchEvent(new Event('television-home'));
    }
    function checkScroll() {
      showBackToTop.value = window.scrollY > 240;
    }
    function scrollToTop() {
      window.scrollTo({
        top: 0,
        behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
      });
    }
    watch(() => route.fullPath, () => {
      drawer.value = false;
    });
    watch(isMobile, v => {
      if (!v) drawer.value = false;
    });
    onMounted(() => {
      if (!isGuidePreview) loadNoticeFeed().catch(() => {});
      window.addEventListener('scroll', checkScroll, {
        passive: true
      });
      checkScroll();
    });
    onUnmounted(() => window.removeEventListener('scroll', checkScroll));
    return (_ctx, _cache) => {
      const _component_router_link = _resolveComponent("router-link");
      const _component_el_icon = _resolveComponent("el-icon");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_drawer = _resolveComponent("el-drawer");
      return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("header", _hoisted_1, [_createElementVNode("nav", _hoisted_2, [_createVNode(_component_router_link, {
        to: "/",
        class: "site-brand",
        "aria-label": "浪漫庄园综合站首页"
      }, {
        default: _withCtx(() => _cache[2] || (_cache[2] = [_createElementVNode("i", {
          class: "adilfont icon-logo2",
          "aria-hidden": "true"
        }, null, -1), _createElementVNode("span", null, "浪漫综合站", -1)])),
        _: 1
      }), !isMobile.value ? (_openBlock(), _createElementBlock("div", _hoisted_3, [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(navigation, item => {
        return _createVNode(_component_router_link, {
          key: item.to,
          to: item.to,
          class: _normalizeClass({
            active: isActive(item.to)
          }),
          "aria-current": isActive(item.to) ? 'page' : undefined,
          onClick: $event => select(item.to)
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(item.short), 1), item.to === '/announcements' && unread.value ? (_openBlock(), _createElementBlock("span", _hoisted_4)) : _createCommentVNode("", true)]),
          _: 2
        }, 1032, ["to", "class", "aria-current", "onClick"]);
      }), 64))])) : (_openBlock(), _createBlock(_component_el_button, {
        key: 1,
        class: "site-menu-button",
        "aria-expanded": drawer.value,
        "aria-controls": "mobile-navigation",
        onClick: _cache[0] || (_cache[0] = $event => drawer.value = true)
      }, {
        default: _withCtx(() => [_createVNode(_component_el_icon, null, {
          default: _withCtx(() => [_createVNode(_unref(Menu))]),
          _: 1
        }), _cache[3] || (_cache[3] = _createElementVNode("span", null, "菜单", -1))]),
        _: 1
      }, 8, ["aria-expanded"]))])]), _createVNode(_component_el_drawer, {
        modelValue: drawer.value,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => drawer.value = $event),
        title: "站点导航",
        direction: "rtl",
        size: "min(85vw, 340px)",
        class: "site-menu-drawer",
        "append-to-body": ""
      }, {
        default: _withCtx(() => [_createElementVNode("nav", _hoisted_5, [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(navigation, item => {
          return _createVNode(_component_router_link, {
            key: item.to,
            to: item.to,
            class: _normalizeClass({
              active: isActive(item.to)
            }),
            "aria-current": isActive(item.to) ? 'page' : undefined,
            onClick: $event => select(item.to)
          }, {
            default: _withCtx(() => [_createVNode(_component_el_icon, null, {
              default: _withCtx(() => [(_openBlock(), _createBlock(_resolveDynamicComponent(item.icon)))]),
              _: 2
            }, 1024), _createElementVNode("span", null, _toDisplayString(item.label), 1), item.to === '/announcements' && unread.value ? (_openBlock(), _createElementBlock("span", _hoisted_6)) : _createCommentVNode("", true), _createVNode(_component_el_icon, {
              class: "nav-arrow"
            }, {
              default: _withCtx(() => [_createVNode(_unref(ArrowRight))]),
              _: 1
            })]),
            _: 2
          }, 1032, ["to", "class", "aria-current", "onClick"]);
        }), 64))])]),
        _: 1
      }, 8, ["modelValue"]), showBackToTop.value && !drawer.value ? (_openBlock(), _createElementBlock("button", {
        key: 0,
        type: "button",
        class: "site-backtop",
        "aria-label": "返回顶部",
        title: "返回顶部",
        onClick: scrollToTop
      }, [_createVNode(_component_el_icon, null, {
        default: _withCtx(() => [_createVNode(_unref(Top))]),
        _: 1
      })])) : _createCommentVNode("", true)], 64);
    };
  }
};